module.exports = __webpack_public_path__ + "frontend/images/homepage/carousel/mobile/1.png?1da18ae366be9ff2a0b5c74bc41f0d22";